import React from "react";
import {
  ColumnDirective,
  ColumnsDirective,
  GridComponent,
} from "@syncfusion/ej2-react-grids";
import "./Component.css";

import axiosClient from "../Utils/axiosClient.js";
import { useTranslation } from "react-i18next";

const Datagrid = () => {
  const [data, setData] = React.useState([]);
  const { t } = useTranslation();
  React.useEffect(() => {
    const fetchLastMessages = async () => {
      try {
        const response = await axiosClient.get(
          "/webhook/Conversations/?$inlinecount=allpages&$orderby=timestamp%20desc&$skip=0&$top=5"
        );

        if (response.status === 200) {
          const formattedData = response.data;
          setData(formattedData);
        }
      } catch (error) {}
    };
    fetchLastMessages();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <GridComponent
        id="adaptivebrowser"
        dataSource={data}
        width={"100%"}
        style={{ border: "none", zIndex: "999",boxShadow:"none" }}
      >
        <ColumnsDirective>
          <ColumnDirective field="timestamp" headerText={t("Time")} />
          <ColumnDirective
            field="messageContent"
            headerText={t("Message Content")}
          />
          <ColumnDirective
            field="receipentPhoneNr"
            headerText={t("Receipent")}
          />
        </ColumnsDirective>
      </GridComponent>
    </>
  );
};
export default Datagrid;
